<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="nickname">
      <a-input v-model="form.data.nickname"/>
    </a-form-model-item>
    <a-form-model-item label="openId">
      <a-input v-model="form.data.openId"/>
    </a-form-model-item>
    <a-form-model-item label="avatar">
      <a-input v-model="form.data.avatar"/>
    </a-form-model-item>
    <a-form-model-item label="remark">
      <a-input v-model="form.data.remark"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
      <a-button type="primary" v-if="!userId" @click="onAdd">创建</a-button>
      <a-button type="primary" v-if="userId" @click="onUpdate">更新</a-button>
      <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryUser,
  _addUser,
  _updateUser,
} from '@/api/userApi';

async function getUser() {
  const result = await _queryUser(this.userId);
  if (result) {
    this.form.data.nickname = result.user.nickname;
    this.form.data.openId = result.user.openId;
    this.form.data.avatar = result.user.avatar;
    this.form.data.remark = result.user.remark;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addUser({
        nickname: this.form.nickname,
        openId: this.form.openId,
        avatar: this.form.avatar,
        remark: this.form.remark,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateUser(this.userId, {
        nickname: this.form.data.nickname,
        openId: this.form.data.openId,
        avatar: this.form.data.avatar,
        remark: this.form.data.remark,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'UserEdit',
  props: {
    userId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    userId() {
      if (this.userId) {
        this.getUser();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getUser,
  },
  data() {
    return {
      form: {
        data: {
          nickname: '',
          openId: '',
          avatar: '',
          remark: '',
        },
        title: '',
      },
    };
  },
  created() {
    if (this.userId) {
      this.getUser();
    }
  },
};
</script>
